<template>
  <vs-popup class="customer-user-create-popup"
            id="popup"
            title="CREATE CUSTOMER USER"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateCustomerUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="title" name="title" rules="" v-slot="{ errors }">
                <small class="label">Title</small>
                <v-select :clearable="false" placeholder="" v-model="createForm.title" :reduce="option => option" :options="['Mr.','Mrs.','Miss']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
<!--                <vs-input v-model="createForm.title"   name="title" class="w-full required" label=""/>-->
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                <small class="label">First Name</small>
                <vs-input v-model="createForm.first_name"   name="first_name" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                <small class="label">Last Name</small>
                <vs-input  v-model="createForm.last_name" class="w-full"  name="last_name" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="job_title" name="job_title" rules="" v-slot="{ errors }">
                <small class="label">Job Title</small>
                <vs-input v-model="createForm.job_title"   name="job_title" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input v-model="createForm.email"   name="email" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="role_id" name="role_id" rules="" v-slot="{ errors }">
                <small class="label">Customer Portal Role</small>
                <v-select name="role_id" label="name" :closeOnSelect="true"  :reduce="option => option.id" v-model="createForm.role_id" :options="roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-1/2">
              <ValidationProvider vid="site_telephone" name="site_telephone" rules="" v-slot="{ errors }">
                <small class="label">Country Code</small>
                <v-select :filter-by="myFilter" :clearable="false" placeholder="code" label="isd_code" v-model="createForm.country_code_main_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.isd_code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider vid="telephone" name="telephone" rules="tel|min_tel|max_tel" v-slot="{ errors }">
                <small class="label">Main Telephone</small>
                <vs-input  v-model="createForm.main_telephone" class="w-full"  name="telephone" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-1/2">
              <ValidationProvider vid="country_code_secondary_telephone" name="country_code_secondary_telephone" rules="" v-slot="{ errors }">
                <small class="label">Country Code</small>
                <v-select :filter-by="myFilter" :clearable="false" placeholder="code" label="isd_code" v-model="createForm.country_code_secondary_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.isd_code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider vid="secondary_telephone" name="secondary_telephone" rules="tel|min_tel|max_tel" v-slot="{ errors }">
                <small class="label">Secondary Telephone</small>
                <vs-input  v-model="createForm.secondary_telephone" class="w-full"  name="secondary_telephone" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="types" name="types" rules="" v-slot="{ errors }">
                <small class="label">Nimble User Role</small>
                <v-select name="role_id" label="name" :closeOnSelect="true"  :reduce="option => option.value" v-model="createForm.types" 
                  :options="customer_user_types" multiple :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <vs-table class="mt-8" stripe :data="createForm.employment_history">
            <template slot="header">
              <h3>
                Employment History
              </h3>
            </template>
            <template slot="thead">
              <vs-th width="20%">Previous Emp</vs-th>
              <vs-th width="20%">Job Title</vs-th>
              <vs-th width="15%">Start Date</vs-th>
              <vs-th width="15%">End Date</vs-th>
              <vs-th width="25%">Note</vs-th>
              <vs-th width="5%"></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].previous_employer">
                  <vs-input  v-model="data[indextr].previous_employer" class="w-full"  name="previous_employer" type="text" label="" />
                </vs-td>

                <vs-td :data="data[indextr].job_title">
                  <vs-input  v-model="data[indextr].job_title" class="w-full"  name="previous_employer" type="text" label="" />
                </vs-td>

                <vs-td :data="data[indextr].start_date">
<!--                  <vs-input  v-model="data[indextr].start_date" class="w-full"  name="previous_employer" type="text" label="" />-->
                  <flat-pickr
                    class="w-full"
                    :config="{ dateFormat: 'd/m/Y'}"
                    v-model="data[indextr].start_date"
                    placeholder="Choose Date"
                  />
                </vs-td>

                <vs-td :data="data[indextr].end_date">
<!--                  <vs-input  v-model="data[indextr].end_date" class="w-full"  name="previous_employer" type="text" label="" />-->
                  <flat-pickr
                    class="w-full"
                    :config="{ dateFormat: 'd/m/Y'}"
                    v-model="data[indextr].end_date"
                    placeholder="Choose Date"
                  />
                </vs-td>

                <vs-td :data="data[indextr].note">
                  <vs-input  v-model="data[indextr].note" class="w-full"  name="previous_employer" type="text" label="" />
                </vs-td>

                <vs-td :data="data[indextr].note">
                  <vs-button class="mt-4 mb-4 ml-4" @click="deleteEmpHistory(indextr)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
                </vs-td>

              </vs-tr>
            </template>

          </vs-table>
          <vs-button class="mt-4 mb-4 ml-4" @click="addEmpHistory" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add Emp History</vs-button>
              <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import flatPickr from 'vue-flatpickr-component'
  import SageFactory from '@/mixins/SageFactory';
  import { mapActions, mapGetters } from 'vuex'

  function initialState() {
    return {
      open: false,
      createForm: {
        employment_history: [

        ],
        types: []
      },
      customer_id: null,
      countryCodes: [],
      roles: [],
      sage_id: null
    }
  }

export default {
  name: 'CreateCustomerUserPopUp',
  data () {
    return initialState()
  },
  methods:{
    ...mapActions(['fetchCustomerUserTypes']),
    async openPopup (id, sage_id) {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.customer_id = id
        this.sage_id = sage_id
        await this.loadCountrCode()
        await this.fetchRoles()
        await this.fetchCustomerUserTypes()
        this.open = true;
      } catch (error) {

      }
    },
    async onClickCreateCustomerUser () {
      const vue = this;
      this.$vs.loading()
       try {
        this.createForm.customer_id = this.customer_id
         const { data } = (await CustomerRepository.createCustomerUser(this.createForm)).data

         if(!!this.sage_id) {
            await this.createCustomerSageContact(this.sage_id, data)
         }
         this.showSuccessMessage('New Customer user created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async loadCountrCode() {
      this.$vs.loading()
      const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
      this.countryCodes =  data
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    addEmpHistory() {
      this.createForm.employment_history.push({previous_employer: '', job_title: '', start_date: '', end_date: '', note: ''})
    },
    deleteEmpHistory(index) {
      this.createForm.employment_history.splice(index, 1)
    },
    async fetchRoles() {
      this.$vs.loading()
      const {data} = (await CustomerRepository.getCustomerRoles()).data
      this.roles = data
      this.$vs.loading.close()
    },

  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
    flatPickr,
  },
  mixins: [SuccessMessage, ErrorMessages, SageFactory],
  computed: {
    ...mapGetters(['customer_user_types'])
  }
}
</script>

<style scoped>
  .customer-user-create-popup >>> .vs-popup {
    min-height: 50% !important;
    min-width: 80% !important;
  }


</style>
